import { message } from 'antd'
import { adminApi } from '~/api'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useNavigate } from 'react-router-dom'
import { showErrors } from '~/utils/helpers'

export const useUpdateCourseSettingMutation = (courseId) => {
  const queryClient = useQueryClient()

  return useMutation(
    async ({ field, checked }) => {
      return await adminApi.updateCourseSettings(courseId, {
        [field]: checked
      })
    },
    {
      onSuccess: async () => {
        await Promise.all([
          queryClient.invalidateQueries({ queryKey: ['courses'] }),
          queryClient.invalidateQueries({ queryKey: ['course'] })
        ])
        message.success('Success')
      },
      onError: showErrors
    }
  )
}

export const useEditTemplateMutation = (courseId) =>
  useMutation(
    async (payload) => {
      const { data } = await adminApi.editEmailTemplate(courseId, payload)
      return data.data
    },
    {
      onSuccess: () => {
        message.success('Success')
      },
      onError: (error) => {
        message.error(error.response?.data?.message)
      }
    }
  )

export const useRestoreTemplateMutation = (courseId) =>
  useMutation(
    async () => {
      const { data } = await adminApi.restoreEmailTemplate(courseId)
      return data.data
    },
    {
      onSuccess: () => {
        message.success('Success')
      },
      onError: (error) => {
        message.error(error.response?.data?.message)
      }
    }
  )

export const useDuplicateCourseMutation = () => {
  const history = useNavigate()
  return useMutation(async (courseId) => await adminApi.duplicateCourse(courseId), {
    onSuccess: (response) => {
      history(`/admin/courses/edit/${response.data.data.id}`)
      message.success('Course duplicated successfully')
    }
  })
}

export const useAssignCourseUser = (courseId) => {
  const queryClient = useQueryClient()
  return useMutation(
    async ({ user_id: userId }) => await adminApi.assignCourseUser(courseId, userId),
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['courses', courseId] })
        message.success('Add user successfully')
      }
    }
  )
}

export const useDeleteCourseMutation = () => {
  const history = useNavigate()
  return useMutation(async (courseId) => await adminApi.removeCourse(courseId), {
    onSuccess: () => {
      history('admin/courses')
      message.success('Course deleted successfully')
    }
  })
}

export const useUploadAttachmentMutation = (courseId) => {
  const queryClient = useQueryClient()

  return useMutation(
    async (file) => {
      await adminApi.uploadCourseEmailAttachments(courseId, file)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['courses_attachments', courseId] })
      }
    }
  )
}

export const useDeleteEmailAttachmentMutation = (courseId) => {
  const queryClient = useQueryClient()
  return useMutation(
    async (fileId) => {
      await adminApi.deleteCourseAttachment(courseId, fileId)
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: ['courses_attachments', courseId] })
      }
    }
  )
}
